import { onReady } from './SegmentAnalytics'
import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()

const STAGING_AND_DEVELOPMENT_AGGREGATE_KEY = 'UA-27527914-39'
const PRODUCTION_AGGREGATE_KEY = 'UA-27527914-32'
const AGGREGATE_TRACKER_NAME = 'aggregateTracker'

const aggregateKey = () => {
  const { NODE_ENV } = publicRuntimeConfig

  if (NODE_ENV === 'production') {
    return PRODUCTION_AGGREGATE_KEY
  }

  return STAGING_AND_DEVELOPMENT_AGGREGATE_KEY
}

const pageTypeDimension = () => {
  const { NODE_ENV } = publicRuntimeConfig

  if (NODE_ENV === 'production') {
    return 'dimension1'
  }

  return 'dimension1'
}

const siteDimension = () => {
  const { NODE_ENV } = publicRuntimeConfig

  if (NODE_ENV === 'production') {
    return 'dimension3'
  }

  return 'dimension2'
}

const enqueueCall = (callback) => {
  if (window.googleAnalyticsAggregatorInitialized) {
    callback()
    return
  }

  if (!window.delayedGoogleAnalyticsCalls) {
    window.delayedGoogleAnalyticsCalls = []
  }
  window.delayedGoogleAnalyticsCalls.push(callback)

  initialize()
}

const initialize = () => {
  if (window.googleAnalyticsAggregatorInitializing) {
    return
  }
  window.googleAnalyticsAggregatorInitializing = true

  onReady(() => {
    window.ga('create', aggregateKey(), 'auto', { name: AGGREGATE_TRACKER_NAME })
    window.googleAnalyticsAggregatorInitialized = true
    window.delayedGoogleAnalyticsCalls.forEach((callback) => callback())
    window.delayedGoogleAnalyticsCalls = []
  })
}

const getDimensions = (domain, pageName = null) => {
  const options = {}
  options[siteDimension()] = domain
  if (pageName) {
    options[pageTypeDimension()] = pageName
  }
  return options
}

export const trackEvent = (domain, category, action) => {
  enqueueCall(() => window.ga(`${AGGREGATE_TRACKER_NAME}.send`, 'event', category, action))
}

export const setUser = (userId) => {
  enqueueCall(() => {
    window.ga(`${AGGREGATE_TRACKER_NAME}.set`, 'userId', userId)
  })
}

export const pageView = (domain, pageName) => {
  enqueueCall(() => {
    const options = getDimensions(domain, pageName)
    window.ga(`${AGGREGATE_TRACKER_NAME}.send`, 'pageview', options)
  })
}
